import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import s from './s.module.less';

type Props = {
    content: string; //markdownContent
    size?: 'small' | 'medium' | 'large';
};
const MarkdownRenderer = (props: Props) => {
    const { content, size = 'medium' } = props;
    return (
        <div className={`${s.wrap} ${size === 'small' ? s.wrapSmall : ''}`}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
    );
};

export default MarkdownRenderer;
